import { createSelector } from 'reselect'

const getStorefrontVisitorData = state => state.storefront.visitor
const getUserData = state => state.user

const storefrontVisitorMetricsSelector = createSelector(
	[getStorefrontVisitorData, getUserData],
	(visitorState, userState) => {

		const ownerUserData = {}
		ownerUserData.userGrades = visitorState.data.grades
		ownerUserData.userSubjects = visitorState.data.subjects
		ownerUserData.followersCount = visitorState.data.owner_follow_data.data.ownerFollowersCount

		ownerUserData.accountDate = visitorState.data.owner_account_date ? new Date(parseInt(visitorState.data.owner_account_date)*1000).toISOString() : ''
		ownerUserData.ownerId = visitorState.data.owner_follow_data ? visitorState.data.owner_follow_data.data.entityUID : ''
		const lessonsCount = visitorState.lessons.count ? visitorState.lessons.count : ''

		return {
			'Number of Lessons': lessonsCount,
			'Number of Followers': ownerUserData.followersCount,
			'Number of Downloads': visitorState.data.downloads,
			'Owner Sign Up Date': ownerUserData.accountDate,
			'Lesson Grades': ownerUserData.userGrades,
			'Lesson Subjects': ownerUserData.userSubjects,
			'Logged In': userState.logged,
			'Owner Id': ownerUserData.ownerId,
		}
	}
)

export default storefrontVisitorMetricsSelector
